import { STEP_SLUGS, type StepSlug, type Store } from '@fiverr-private/store_builder_types';
import { getAvailableSteps } from '../../lib/utils/stepCalculator/stepUtils';

export const getNextStep = (currentStep: string, storeData?: Store): StepSlug | null => {
    const availableSteps = getAvailableSteps(storeData);
    const currentIndex = availableSteps.indexOf(currentStep as StepSlug);

    if (currentIndex === -1 || currentIndex === availableSteps.length - 1) {
        return 'publish';
    }

    return availableSteps[currentIndex + 1];
};

export const getPreviousStep = (currentStep: string, storeData?: Store): StepSlug => {
    const availableSteps = getAvailableSteps(storeData);
    const currentIndex = availableSteps.indexOf(currentStep as StepSlug);

    if (currentIndex <= 0) {
        return 'choose-niche'; // first step
    }

    return availableSteps[currentIndex - 1];
};

export const isValidStepSlug = (stepSlug?: string): stepSlug is StepSlug =>
    !!stepSlug && STEP_SLUGS.includes(stepSlug as StepSlug);

export const getCurrentStep = (pathname: string): StepSlug => {
    const currentPath = pathname.split('/').pop() || '';

    if (isValidStepSlug(currentPath)) {
        return currentPath;
    }

    return 'choose-niche'; // default step
};

export const isStepAccessible = (stepSlug: StepSlug, storeData?: Store): boolean => {
    const availableSteps = getAvailableSteps(storeData);
    return availableSteps.includes(stepSlug);
};
